<template>
  <div class="pdf-report-medicine-stock-total">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <v-btn
                v-if="!showSelectMedice && !medicine_id"
                class="v-success btn-block"
                @click="handleShowSelectMedice(true)"
              >
                FILTRAR POR MEDICAMENTO
              </v-btn>
              <v-btn
                v-if="showSelectMedice"
                class="v-dark btn-block"
                @click="handleShowSelectMedice(false)"
              >
                NÃO FILTRAR POR MEDICAMENTO
              </v-btn>
              <v-btn
                v-if="medicine_id"
                class="v-danger btn-block"
                @click="handleShowSelectMedice(false)"
              >
                LIMPAR FILTRO DO MEDICAMENTO
              </v-btn>
            </div>
            <div class="col-md-12 pt-0 pb-0" v-if="showSelectMedice">
              <SelectMedicineID
                :showMedicine="false"
                :newMedicine="false"
                :rest_home_id="rest_home_id"
                @selected="selectedMedice"
              />
            </div>
            <div class="col-md-12" v-if="medicine_id && medicineSelected">
              <p class="m-0">MEDICAMENTO: {{ medicineSelected.name }}</p>
              <p class="m-0">
                PRINCÍPIO ATIVO: {{ medicineSelected.active_ingredient }}
              </p>
              <p class="m-0">
                RECEITA: {{ medicineSelected.type_of_recipe_name }}
              </p>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label>TIPO DE RECEITA</label>
              <select v-model="type_of_recipe_id" class="form-control">
                <option value="">TODAS</option>
                <option
                  v-for="value in typesOfRecipe"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div class="col-md-12">
              <label>RESIDENTES ATIVOS/INATIVOS/TODOS</label>
              <select
                v-model="resident_active"
                class="form-control"
                @change="getResidents"
              >
                <option value="TODOS">TODOS</option>
                <option value="ATIVO">ATIVOS</option>
                <option value="INATIVO">INATIVOS</option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label>EMPRESA/RESIDENTE/TODOS</label>
              <select v-model="resident_id" class="form-control">
                <option
                  v-if="
                    rest_home_allow_home_care != 1 && user_allow_home_care != 1
                  "
                  value=""
                >
                  TODOS
                </option>
                <option
                  v-if="
                    rest_home_allow_home_care != 1 && user_allow_home_care != 1
                  "
                  value="rest_home_id"
                >
                  EMPRESA
                </option>
                <option
                  v-for="(resident, key) in residents"
                  :key="key"
                  :value="resident.id"
                >
                  {{ String(resident.name).toUpperCase() }} -
                  {{ String(resident.status_type_name).toUpperCase() }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pb-0">
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12 text-right">
              <v-btn
                :disabled="loading"
                @click="paginate()"
                class="btn-filter"
                type="relief"
                ><i class="fas fa-filter mr-2 text-twenty"></i>
                {{ loading ? "CARREGANDO" : "FILTRAR" }}
              </v-btn>
            </div>
          </div>
        </div>
      </b-modal>
      <div class="row content-filter">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: ESTOQUE DE MEDICAMENTOS
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="medicines.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="medicines.length > 0"
        >
          <h6
            class="mb-0 upper-text worksansr check-text-center"
            v-if="resident_id || medicine_id || type_of_recipe_id"
          >
            FILTRANDO:
            <span v-if="resident_id"><strong>RESIDENTE</strong></span>
            <span v-if="medicine_id"><strong>MEDICAMENTO</strong></span>
            <span v-if="type_of_recipe_id"><strong>RECEITA</strong></span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="medicines.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div class="table-responsive">
          <table
            class="table-always"
            v-for="(medicine, medicineKey) in medicines"
            :key="medicineKey"
          >
            <thead>
              <tr>
                <td>
                  <div class="header-space">
                    <div class="row">
                      <div class="col-md-8">
                        <h5 class="m-0">
                          {{ medicine.medicine_name }}
                        </h5>
                        <h6 class="m-0">
                          {{ medicine.active_ingredient }}
                        </h6>
                        <h6 class="m-0">
                          {{ medicine.type_of_recipe_name }}
                        </h6>
                      </div>
                      <div
                        class="col-md-4 d-flex align-items-center justify-content-end"
                      >
                        <img
                          class="logo"
                          src="https://sistemclinupload.s3.amazonaws.com/logo.png"
                          width="180"
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div class="content">
                    <p class="m-0 text-center">
                      TOTAL EM ESTOQUE: {{ medicine.total }}
                      {{ medicine.unit_of_measurement_abbreviation }}
                    </p>
                    <div class="table-responsive text-nowrap">
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th>PROPRIETÁRIO</th>
                            <th>ESTOQUE</th>
                            <th>QUANTIDADE EM ESTOQUE</th>
                            <th>LOTE</th>
                            <th>ENTRADA</th>
                            <th>VENCIMENTO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(lot, lotKey) in medicine.lots"
                            :key="`${medicineKey}-${lotKey}`"
                          >
                            <td>{{ lot.owner_name }}</td>
                            <td>{{ lot.stock_group_name }}</td>
                            <td>
                              {{ lot.amount }}
                              {{ medicine.unit_of_measurement_abbreviation }}
                            </td>
                            <td>{{ lot.lot }}</td>
                            <td>
                              <span v-if="lot.entry_date">
                                {{
                                  moment(lot.entry_date).format("DD/MM/YYYY")
                                }}
                              </span>
                            </td>
                            <td>
                              <span v-if="lot.due_date">
                                {{ moment(lot.due_date).format("MM/YYYY") }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="footer text-center">
                    <hr class="mb-1 border-black" />
                    <h6 class="mb-0 worksansr">
                      (Assinatura eletrônica)
                      <strong>
                        {{
                          professionalClassCouncilValue({
                            id: user.professional_class_council_id,
                            name: user.name,
                            profile: user.profile_name,
                            cpf: user.cpf,
                            office: user.office,
                            value: user.professional_class_council_value,
                          })
                        }}
                        <span class="ml-1">
                          - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                        </span>
                      </strong>
                    </h6>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div class="footer-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import SelectMedicineID from "../Components/SelectMedicineID";

import api from "../../services/api";

import routes from "../../routes";

import {
  formatDate,
  formatDateToMonthYear,
  professionalClassCouncilValue,
} from "../../lib/format";

import { getAge } from "../../lib/getAgeByDate";

import { userData } from "../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsMedicineStockTotal",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    SelectMedicineID,
  },

  data() {
    return {
      rest_home_id: "",
      resident_active: "ATIVO",
      type_of_recipe_id: "",
      resident_id: "",
      medicine_id: "",
      medicineSelected: null,
      residents: [],
      typesOfRecipe: [],
      medicines: [],
      user: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      loadingFilterMedicines: false,
      loading: false,
      showSelectMedice: false,
      errors: [],

      user_allow_home_care: 0,
      rest_home_allow_home_care: 0,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    moment,
    formatDate,
    formatDateToMonthYear,
    professionalClassCouncilValue,

    handleShowSelectMedice(showSelectMedice) {
      this.medicine_id = "";
      this.showSelectMedice = showSelectMedice;
    },

    selectedMedice(medicine) {
      this.errors = [];

      if (medicine.id) {
        this.medicineSelected = medicine;
        this.medicine_id = medicine.id;
      } else {
        this.medicineSelected = null;
        this.medicine_id = "";
      }

      this.showSelectMedice = false;
    },

    async retrieve() {
      const { user } = userData();

      this.user = user;
      this.rest_home_id = user.rest_home_id;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.user_allow_home_care = user.allow_home_care;
      this.rest_home_allow_home_care = user.rest_home_allow_home_care;

      await this.getResidents();
      await this.getTypesOfRecipe();

      if (this.errors.length == 0 && this.resident_id) {
        await this.paginate();
      }

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },

    async getResidents() {
      try {
        let { resident_active } = this;

        let status = "ATIVO";

        if (resident_active == "TODOS") {
          status = "ALL";
        } else if (resident_active == "INATIVO") {
          status = "INATIVO";
        } else if (!["TODOS", "ATIVO", "INATIVO"].includes(resident_active)) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypesOfRecipe() {
      try {
        const response = await api.get("/rest-home/type-of-recipe/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfRecipe = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        const { type_of_recipe_id, resident_id, medicine_id, resident_active } =
          this;

        var params = {
          type_of_recipe_id,
          resident_id,
          medicine_id,
          resident_active,
        };

        const response = await api.get(
          "/rest-home/report/medicine-stock-total",
          {
            params,
          }
        );

        const { medicines, error, errors } = response.data;

        if (error) {
          this.medicines = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = medicines;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToPrint: () => window.print(),

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.pdf-report-medicine-stock-total p {
  font-weight: 100 !important;
}
.pdf-report-medicine-stock-total .text-amount {
  font-size: 13px;
}

.pdf-report-medicine-stock-total .date-amount {
  font-size: 13px;
}

.pdf-report-medicine-stock-total .header,
.pdf-report-medicine-stock-total .header-space {
  height: 150px;
}

.pdf-report-medicine-stock-total .footer,
.pdf-report-medicine-stock-total .footer-space {
  height: 50px;
}

.pdf-report-medicine-stock-total .header {
  position: fixed;
  top: 0;
}

.pdf-report-medicine-stock-total .logo {
  width: 100%;
  height: 50px;
  object-fit: contain;
}

.pdf-report-medicine-stock-total .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-medicine-stock-total .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-medicine-stock-total .table-always,
.pdf-report-medicine-stock-total td,
.pdf-report-medicine-stock-total th {
  width: 100% !important;
  cursor: auto !important;
}

.pdf-report-medicine-stock-total th {
  background-color: #f5f5f5;
}

.pdf-report-medicine-stock-total .medicine-name {
  font-size: 14px;
}

.pdf-report-medicine-stock-total small {
  font-size: 12px;
}

@media print {
  .pdf-report-medicine-stock-total .table-always {
    width: 100% !important;
    border: none !important;
  }

  .pdf-report-medicine-stock-total .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .pdf-report-medicine-stock-total .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-medicine-stock-total .content-movimentation {
    page-break-inside: avoid !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .pdf-report-medicine-stock-total .table-always {
    page-break-before: always !important;
  }

  .pdf-report-medicine-stock-total .header,
  .pdf-report-medicine-stock-total .header-space {
    height: 150px;
  }

  body {
    margin: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-medicine-stock-total button {
    display: none;
  }

  .pdf-report-medicine-stock-total .nav--bar {
    display: none !important;
  }

  .pdf-report-medicine-stock-total .auth--by--session--expired {
    display: none !important;
  }

  .pdf-report-medicine-stock-total .content-filter {
    display: none;
  }
}
</style>
